/* eslint-disable no-undefined */
export const isPropertyEmpty = (property: any) =>
  property === null || property === undefined;

export const boolToOnOff = (value: boolean) => (value ? 'on' : 'off');
